import { Tag } from 'lucide-react';

import { NodeShell } from './NodeShell';

export const RunClassifierNode = ({
  data,
  selected,
}: {
  data: { label: string; outputKey?: string };
  selected?: boolean;
}) => (
  <NodeShell
    type="run_classifier"
    icon={<Tag size={16} />}
    label={data.label}
    subtitle={data.outputKey ? `→ ${data.outputKey}` : undefined}
    selected={selected}
  />
);
